import { useParams } from 'react-router-dom'
import { useProjectDashboard, useProject } from './useProject'
import { Card, ErrorBanner, FormattedDate, Loading } from '../../components/ui'

export function ProjectDashboard() {
  const { projectId } = useParams<{ projectId: string }>()
  const project = useProject(projectId)
  const dashboard = useProjectDashboard(projectId)

  if (dashboard.isLoading) return <Loading />
  if (dashboard.isError) return <ErrorBanner error={dashboard.error} />

  const totals = dashboard.data?.totals ?? {}
  const totalsEntries = Object.entries(totals)

  return (
    <div className="grid gap-6">
      {totalsEntries.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {totalsEntries.map(([key, value]) => (
            <Card key={key}>
              <div className="text-xs uppercase tracking-wide text-surface-400">
                {key.replace(/_/g, ' ')}
              </div>
              <div className="text-xl font-semibold mt-1">{value}</div>
            </Card>
          ))}
        </div>
      )}

      <Card>
        <h2 className="font-semibold mb-3">Project</h2>
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 text-sm">
          <dt className="text-surface-400">Lead</dt>
          <dd>{project.data?.primary_site_lead_name ?? '—'}</dd>
          <dt className="text-surface-400">Start</dt>
          <dd>
            <FormattedDate ts={project.data?.start_date ?? null} />
          </dd>
          <dt className="text-surface-400">End</dt>
          <dd>
            <FormattedDate
              ts={project.data?.target_end_date ?? project.data?.end_date ?? null}
            />
          </dd>
          {project.data?.client_name && (
            <>
              <dt className="text-surface-400">Client</dt>
              <dd>{project.data.client_name}</dd>
            </>
          )}
          {project.data?.description && (
            <>
              <dt className="text-surface-400">Description</dt>
              <dd>{project.data.description}</dd>
            </>
          )}
        </dl>
      </Card>

      {dashboard.data?.recent_activity && dashboard.data.recent_activity.length > 0 && (
        <Card>
          <h2 className="font-semibold mb-3">Recent activity</h2>
          <ul className="divide-y divide-surface-700 text-sm">
            {dashboard.data.recent_activity.map((a) => (
              <li key={a.id} className="py-2 flex justify-between gap-3">
                <span className="text-surface-100">{a.description}</span>
                <span className="text-surface-400 text-xs whitespace-nowrap">
                  <FormattedDate ts={a.created_at} />
                </span>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  )
}
